import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { EmmirErrorActionType, ErrorAction } from './actions-types';
import { ERROR } from './mutation-types';
import { ErrorToasterState } from './state';

export const actions: ActionTree<ErrorToasterState, RootState>  = {
    async [ErrorAction.DEACTIVATE_TOAST]({ commit }: EmmirErrorActionType) : Promise<void> {
        commit(ERROR.SET_ACTIVE, false);
    }
};